import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IActiveSource,
  IGetAllSourceRegistries
} from '../../actions/types/sources/GetAllSourceRegistries';

/**
 * Initial All Source Registry state in store
 */
export const initialState: IGetAllSourceRegistries = {
  isLoading: false,
  listSourceRegistryErrorMessage: '',
  sourceData: {
    currentPageNumber: 0,
    numberOfRecordsPerPage: 10,
    totalRecords: 0,
    numberOfPages: 0,
    sources: []
  }
};

const fetchSourceRegistryListSlice = createSlice({
  name: 'fetchSourceRegistryList',
  initialState,
  reducers: {
    fetchSourceRegistryListStarted: (state) => {
      state.isLoading = true;
    },

    fetchSourceRegistryListSuccess: (
      state,
      action: PayloadAction<IActiveSource>
    ) => {
      state.isLoading = false;
      state.sourceData = action.payload;
      state.listSourceRegistryErrorMessage = '';
    },

    fetchSourceRegistryListFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.sourceData = initialState.sourceData;
      state.listSourceRegistryErrorMessage = action.payload;
    },

    clearSourceRegistryListDetails: (state) => {
      state.isLoading = false;
      state.sourceData = initialState.sourceData;
      state.listSourceRegistryErrorMessage = '';
    }
  }
});
export const {
  fetchSourceRegistryListStarted,
  fetchSourceRegistryListSuccess,
  fetchSourceRegistryListFail,
  clearSourceRegistryListDetails
} = fetchSourceRegistryListSlice.actions;
export default fetchSourceRegistryListSlice.reducer;
